class SoftReloadError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SoftReloadError';
  }
}

export default SoftReloadError;
